import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-9bcfa3c6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "SVideo"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_VideoList = _resolveComponent("VideoList");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_VideoList, {
    videoList: _ctx.videoList,
    isShowLoading: false,
    isScroll: false,
    inputValue: _ctx.inputValue,
    isBlod: true
  }, null, 8
  /* PROPS */
  , ["videoList", "inputValue"])]);
}